export const campaignKeys = {
  all: ["autoleads", "campaign"] as const,
  // Team-scoped list. ``teamId`` is required on purpose: keying a team-scoped
  // list on a null team made it share this entry with the team-agnostic list
  // below, which flashed every team's campaigns before the active team was
  // known. Use ``listAll`` when no team is meant.
  list: (archived: boolean, teamId: number) =>
    [...campaignKeys.all, "list", archived, teamId] as const,
  listAll: () => [...campaignKeys.all, "list-all"] as const,
  staffList: (filters?: { status?: string; team_id?: number; q?: string }) =>
    [...campaignKeys.all, "staff-list", filters ?? {}] as const,
  staffDetail: (id: string | number) =>
    [...campaignKeys.all, "staff-detail", id] as const,
  mailingList: () => [...campaignKeys.all, "mailing-list"] as const,
  detail: (id: string | number) => [...campaignKeys.all, "detail", id] as const,
  costBreakdown: (id: string | number) =>
    [...campaignKeys.all, "cost-breakdown", id] as const,
  progress: (id: string | number) =>
    [...campaignKeys.all, "progress", id] as const,
  digest: (id: string | number) => [...campaignKeys.all, "digest", id] as const,
  mailingLeads: (id: string | number) =>
    [...campaignKeys.all, "mailing-leads", id] as const,
  reenrichPreview: (id: string | number, request: object) =>
    [...campaignKeys.all, "reenrich-preview", id, request] as const,
  targets: (id: string | number) =>
    [...campaignKeys.all, "targets", id] as const,
  reenrichStatus: (id: string | number) =>
    [...campaignKeys.all, "reenrich-status", id] as const,
  importStatus: (id: string | number) =>
    [...campaignKeys.all, "import-status", id] as const,
  importPreview: (teamId: number, kind: string, config: object) =>
    [...campaignKeys.all, "import-preview", teamId, kind, config] as const,
  hubspotLists: (teamId: number | null = null) =>
    [...campaignKeys.all, "hubspot-lists", teamId] as const,
  publicByUuid: (uuid: string) =>
    [...campaignKeys.all, "public", uuid] as const,
  publicProjection: (uuid: string) =>
    [...campaignKeys.all, "public-projection", uuid] as const,
  publicLeads: (uuid: string) =>
    [...campaignKeys.all, "public-leads", uuid] as const,
}
